export default {
  delete_success: 'Oferta a fost ștearsă cu succes',
  delete_failed: 'Ștergerea ofertei a eșuat',
  delete_confirm_title: 'Sigur doriți să ștergeți această ofertă?',
  delete_last_day_confirm_title: 'Eliminarea ultimei zile rămase va șterge această ofertă. Ești sigur?',
  confirm: 'Confirmă',
  cancel: 'Anulează',
  qualifying_items: 'Articole eligibile',
  free_items: 'Articole gratuite',
  all_day: 'Toată ziua',
  starts_on: 'Începe pe {{date}}',
  ends_on: 'Se termină pe {{date}}',
  ends_when_deleted: 'Se termină la ștergere',
  off: '{{amount}} reducere',
  min_spend_value: 'Cheltuială minimă: {{amount}}',
};
